import { SocialMediaType } from '@prisma/client';

const getUrl = (baseUrl: string, text: string, isHttpUrl: boolean = true) => `<a
href="${baseUrl}${isHttpUrl ? text.slice(1) : ''}"
target="_blank"
class="text-[#2b5db9] hover:underline no-underline"
>
${text}
</a>`;

type CaptionProps = {
  caption: string;
  type?: SocialMediaType;
};

export const getMentionUrl = (type: SocialMediaType) => {
  if (type === SocialMediaType.INSTAGRAM) {
    return 'https://www.instagram.com/';
  }
  if (type === SocialMediaType.TIKTOK) {
    return 'https://www.tiktok.com/@';
  }
  if (type === SocialMediaType.LINKEDIN) {
    return 'https://linkedin.com/in/';
  }
  if (type === SocialMediaType.X) {
    return 'https://x.com/';
  }
  if (type === SocialMediaType.FACEBOOK) {
    return 'https://www.facebook.com/people/';
  }
  if (type === SocialMediaType.YOUTUBE) {
    return 'https://www.youtube.com/@';
  }
  return '';
};

const getHashtagUrl = (type: SocialMediaType) => {
  if (type === SocialMediaType.INSTAGRAM) {
    return 'https://www.instagram.com/explore/tags/';
  }
  if (type === SocialMediaType.TIKTOK) {
    return 'https://www.tiktok.com/tag/';
  }
  if (type === 'LINKEDIN') {
    return 'https://www.linkedin.com/feed/hashtag/';
  }
  if (type === 'X') {
    return 'https://x.com/hashtag/';
  }
  return '';
};

export default function Caption({ caption, type }: CaptionProps) {
  const hashtags = caption.match(/#\w+/g)?.flat() ?? [];
  const mentions = caption.match(/@\w+/g)?.flat() ?? [];
  const httpUrls = caption.match(/https?:\/\/[^\s]+/g)?.flat() ?? [];
  let formattedCaption = caption;

  httpUrls.forEach((m) => {
    formattedCaption = formattedCaption.replaceAll(m, getUrl(m, m, false));
  });
  if (type) {
    const hashtagUrl = getHashtagUrl(type);
    const mentionUrl = getMentionUrl(type);

    hashtags.forEach((t) => {
      formattedCaption = formattedCaption.replaceAll(t, getUrl(hashtagUrl, t));
    });

    mentions.forEach((m) => {
      formattedCaption = formattedCaption.replaceAll(m, getUrl(mentionUrl, m));
    });
  }
  return (
    <div
      className="font-medium mt-1 whitespace-pre-line" // TODO: handle link
      dangerouslySetInnerHTML={{ __html: formattedCaption }}
    ></div>
  );
}
